import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { getTokens } from "../../styles/tokens";

// Estado vazio do painel para "sem permissão": ícone na tinta da marca, frase e volta.
const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    root: {
      flex: 1,
      width: "100%",
      minHeight: 320,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "56px 24px",
      boxSizing: "border-box",
      textAlign: "center",
      fontFamily: t.font,
    },
    icon: {
      width: 48,
      height: 48,
      marginBottom: 14,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: t.radius.md,
      backgroundColor: t.tint.soft,
      color: t.brand,
      "& .MuiSvgIcon-root": { fontSize: 24 },
    },
    code: {
      margin: 0,
      fontSize: 12,
      fontWeight: 600,
      letterSpacing: "0.12em",
      color: t.textMuted,
    },
    title: {
      margin: "6px 0 0",
      fontSize: 18,
      fontWeight: 600,
      lineHeight: 1.35,
      letterSpacing: "-0.01em",
      color: t.text,
    },
    message: {
      margin: "6px 0 0",
      maxWidth: 384,
      fontSize: 13.5,
      lineHeight: 1.5,
      color: t.textSecondary,
    },
    action: { marginTop: 18 },
  };
});

const ForbiddenPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root} role="alert">
      <div className={classes.icon} aria-hidden="true">
        <LockOutlinedIcon />
      </div>
      <p className={classes.code}>403</p>
      <h2 className={classes.title}>Oops! Acesso Negado!</h2>
      <p className={classes.message}>
        Seu perfil não tem permissão para abrir esta página.
      </p>
      <Button
        className={classes.action}
        variant="contained"
        color="primary"
        href="/tickets"
      >
        Voltar
      </Button>
    </div>
  );
};

export default ForbiddenPage;
